import { configureStore } from '@reduxjs/toolkit';

import {
  userSlice,
  wosSlice,
  alertsSlice,
  navigationSlice,
  pagosSlice,
  vendorSlice,
  marketingSlice,
  certificadosSlice,
  helpdeskSlice
} from "../slices";


export const store = configureStore({
  reducer: {
    bi_wos: wosSlice.reducer,
    user: userSlice.reducer,
    alerts: alertsSlice.reducer,
    navigation: navigationSlice.reducer,
    pagos: pagosSlice.reducer,
    marketing: marketingSlice.reducer,
    form_vendor: vendorSlice.reducer,
    certificados: certificadosSlice.reducer,
    helpdesk: helpdeskSlice.reducer
  },
});